module.exports = __webpack_public_path__ + "img/icon-sw.04958869.svg";